/*
  Noah.Q HERO gap-position controller v235

  Position the hero link row at 60% of the REAL empty vertical gap between:
    A) bottom of the hero lead text
    B) bottom of the hero stage (= top edge of the marquee)

  This runs after the v232 virtual-canvas scale is applied, then converts the
  measured screen-space target back into the 1600x784 reference-stage coordinate.
*/
(function () {
  'use strict';

  var DESKTOP = '(min-width: 990px)';
  var GAP_RATIO = 0.60;
  var raf = 0;

  function position() {
    raf = 0;

    if (!window.matchMedia(DESKTOP).matches) return;

    var home = document.querySelector('.noahq-home');
    var stage = home && home.querySelector('.noahq-hero__stage');
    var lead = home && home.querySelector('.noahq-hero__lead');
    var links = home && home.querySelector('.noahq-hero__linkrow');

    if (!home || !stage || !lead || !links) return;

    var stageRect = stage.getBoundingClientRect();
    var leadRect = lead.getBoundingClientRect();
    var scaleRaw = getComputedStyle(home).getPropertyValue('--nq-canvas-scale').trim();
    var scale = parseFloat(scaleRaw);

    if (!Number.isFinite(scale) || scale <= 0 || stageRect.height <= 0) return;

    var gapStart = leadRect.bottom;
    var gapEnd = stageRect.bottom;
    var gap = gapEnd - gapStart;

    if (gap <= 0) return;

    /* 60% from the top of the actual empty gap. */
    var targetScreenY = gapStart + gap * GAP_RATIO;
    var targetReferenceY = (targetScreenY - stageRect.top) / scale;

    /* Keep the row safely inside the reference HERO stage. */
    targetReferenceY = Math.max(0, Math.min(784, targetReferenceY));
    stage.style.setProperty('--nq-hero-link-top', targetReferenceY.toFixed(3) + 'px');
  }

  function schedule() {
    if (raf) return;
    raf = requestAnimationFrame(position);
  }

  function start() {
    schedule();
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('orientationchange', schedule, { passive: true });

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', schedule, { passive: true });
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(schedule).catch(function () {});
    }

    /* v232 controller writes the scale during startup; measure again after it. */
    setTimeout(schedule, 0);
    setTimeout(schedule, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
